<template>
  <div class="flex flex-column align-items-center justify-content-center pt-3 pb-3">
    <PrimevueCard  class="sm:w-12 md:w-8 lg:w-8 xl:w-6 mb-2">
      <template #title>
        <div class="align-items-center flex justify-content-between ">
          <div>KRABICA</div>
          
          <PrimevueTag class="p-1 font-medium text-base justify-content-center" 
                       :value="this.box.opened ? 'otvorená' : 'zatvorená'"
                       :severity="this.box.opened ? 'success' : 'danger'"
                       rounded
          />
        </div>
        
      </template>
      <template #subtitle >
        <div class="mb-3 border-solid border-1 surface-border"></div>
        <div class="field flex justify-content-center">
          <router-link to="/mod-stock/scan-item" class="w-8">
            <PrimevueButton label="Skenovať QR kód" severity="success" icon="pi pi-camera" text raised class="uppercase w-full"/>
          </router-link>
        </div>
        <div class="field flex justify-content-center">
          <PrimevueButton @click="printLabel()" label="Vytlač štítok" 
            :disabled="!(this.box.id > 0)" icon="pi pi-print"
            severity="success" text raised class="w-8 uppercase"/>
        </div>
      
      </template>
      <template #content>
          
        <form @submit.prevent="submitHandler" name="boxForm" class="">
            
            <div class="field">
                <label for="box-code">Kód</label>
                <InputText class="w-full" 

                  v-model="this.box.code"
                  disabled
                  type="text"
                  name="box-code"
                  id="box-code"
                >
                </InputText>

            </div>

            <div class="field">
              <label for="box-location">Umiestnenie</label>
              <InputText class="w-full" 

                v-model="this.box.location"
                type="text"
                name="box-location"
                id="box-location"
              >
              </InputText>
            </div>            

            <div class="field" style="position: relative;">
              <label for="box-order">Objednávka</label>
              <PrimevueButton @click="this.visibleSelect = !this.visibleSelect" 
                  label="test" 
                  style="height: 1.9rem;"
                  class="flex justify-content-between w-full " outlined
                  :class="`${v$.box.order.$error ? 'bg-red-200' : ''}`"
                  
                  id="box-order">
                <span >
                <span v-if="this.box.order.id > 0">
                  <span >{{this.box.order.orderCode}}</span> *
                  <span >{{this.box.customer.lastName}}</span> *
                  <span >{{this.box.customer.city}}</span>
                </span>
                </span>
                <span class="flex justify-content-center align-items-center" style="width: 1.8rem;">
                  <svg width="14" height="14" viewBox="0 0 14 14" 
                        fill="none" xmlns="http://www.w3.org/2000/svg" class="p-icon p-button-icon">
                        <path d="M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z" fill="currentColor"></path>
                  </svg>
                </span>

              </PrimevueButton>
              <div
                  v-for="(error, index) of v$.box.order.$errors"
                  :key="index"
                  class="text-sm font-italic text-red-400"
              >
              {{ error.$message }}
              </div>
              <div v-if="this.visibleSelect" class="card" 
                  style="z-index: 10; position: absolute; top: 56px; left: 2px; min-width: 20rem; transform-origin: center top; margin-top: 2px;">
        
                  <!-- <div class="ml-1 mt-1 flex justify-content-start"> -->
                    <IconField iconPosition="left">
                     
                      <InputIcon>
                        <i class="pi pi-search "/>
                      </InputIcon>
                      <InputText v-model="orderFilters['global'].value" placeholder="Vyhľadať" @input="onOrderFilter" 
                     
                      />
                    </IconField>
                  <!-- </div> -->
                <DataTable
                    
                    lazy paginator :rows="this.selectParams.rows"
                    @page="onOrderPage"
                    :first="this.selectParams.first"
                    :loading="selectLoading"
                    :totalRecords="this.selectParams.totalRecords"
                    dataKey="id"
                    :value="this.orderOptions"
                    :scrollHeight="`${200}px`"
                    :virtualScrollerOptions="{ itemSize: 40 }"
                    stripedRows
                    row-hover
                    scrollable
                    v-model:selection="this.selectedOrder"
                    selectionMode="single"
                    :metaKeySelection="false"
                    @rowSelect="selectOrder(this.selectedOrder)"
                    size="small"
                >
                    <Column header="ID" field="orderCode" style="width: 5%">
                    </Column>
                    <Column header="Meno" field="customer.lastName" style="width: 50%">
                    </Column>    
                    <Column header="Obec" field="customer.city" style="width: 45%">
                    </Column>              
                </DataTable>              
              </div>

            </div>  

            <div class="field">
              <label for="box-customer">Zákazník</label>
              <InputText disabled class="w-full" 

                v-model="this.box.customer.lastName"
                type="text"
                name="box-customer"
                id="box-customer"
              >
              </InputText> 
 
            </div> 

            <div class="field">
              <label for="proform">Cortizo proforma</label>

              <PrimevueSelect
                  id="proform"
                  :editable="this.box.cortizoProform.id == 0"
                  :disabled="!(this.box.order.id > 0)"
                  v-model="this.selectedProform"
                  :options="this.proformOptions"
                  optionLabel="code"
                  placeholder="Vyber alebo zadaj číslo proformy"
                  class="w-full"
                  :class="`${v$.selectedProform.$error ? 'bg-red-200' : ''}`"
                  :invalid="v$.selectedProform.$error"
              >
                <template #value="slotProps">
                  <div v-if="slotProps.value" class="">
                      <div>{{ slotProps.value.code }}</div>
                  </div>
                  <span v-else>
                    Vyber alebo zadaj číslo proformy
                  </span>
                </template>
                <template #option="slotProps">
                    <div class="">
                       <div>{{ slotProps.option.code }}</div>
                    </div>
                </template>
              </PrimevueSelect>  
              <div
                  v-for="(error, index) of v$.selectedProform.$errors"
                  :key="index"
                  class="text-sm font-italic text-red-400"
              >
                {{ error.$message }}
              </div>
            </div>            

            <div class="field flex justify-content-center">
              <PrimevueButton v-if="!this.box.opened" @click="openBox()" label="Otvor krabicu" severity="success" text raised class="w-8 uppercase"/>
              <PrimevueButton v-if="this.box.opened" @click="closeBox()" label="Zatvor krabicu"  severity="secondary" text raised class="w-8 uppercase"/>
            </div>

            <div class="mt-0 mb-2 border-solid border-1 surface-border"></div>
            
            <div class="mb-1 flex flex-wrap justify-content-center gap-3">
                <PrimevueButton type="submit" label="Uložiť" text raised class="uppercase"/>
                <router-link to="/mod-stock/boxies">
                      <PrimevueButton label="Zrušiť" severity="danger" text raised class="uppercase"/>
                </router-link>
            </div>
          </form>
        </template>
    </PrimevueCard>

    <PrimevueCard  class="sm:w-12 md:w-8 lg:w-8 xl:w-6">
      <template #title>Pohyby s krabicou</template>
      <template #subtitle ><div class="mb-3 border-solid border-1 surface-border"></div></template>
      <template #content>
        
            <ul>
              <li v-for="history in this.store.stockMovements" v-bind:key="history.id">
                <i class="pi pi-clock"></i>
                {{ Utils.formatToSlovak(history.createdAt) }}
                <PrimevueTag class="text-base" :value="history.action" :style="{ backgroundColor: history.color }"/>
                - {{ history.user.firstName }} {{ history.user.lastName }}
              </li>
            </ul>
       
      </template>
    </PrimevueCard>
  </div>
  <ConfirmDialog></ConfirmDialog>

</template>


<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import notie from "notie/dist/notie";
import router from "@/router";
import PrimevueButton from 'primevue/button';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import IconField from 'primevue/iconfield';
import InputIcon from "primevue/inputicon";
import PrimevueTag from "primevue/tag";
import PrimevueSelect from "primevue/dropdown";
import {FilterMatchMode} from "primevue/api";
import PrimevueCard from 'primevue/card';
import { required, helpers, minLength  } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Utils from '@/components/utils';

export default {
  name: "BoxEdit",
  components: {
      DataTable,
      Column,
      IconField,
      InputIcon,
      PrimevueButton,
      PrimevueTag,
      PrimevueSelect,
      PrimevueCard,
  },
  computed: {
    Utils() {
      return Utils;
    },
  },
  data() {
    return {
      store,
      actionWithBox: "",
      oldLocation: "",
      typeOfAction: "",
      routeParams : null,
      box: {
        id: 0,
        code: "",
        location: "",
        customer: {id:0,lastName:"",city:""},
        order: {id:0,orderCode:""},
        opened: false,
        received: true,
        receivedAt: Date,
        openedAt: Date,
        cortizoProform:{id:0,code:""}
      },
      orderOptions: [],
      selectedOrder: null,
      visibleSelect: false,
      selectLoading: false,
      orderFilters : {
          global: {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      selectParams: {
        first: 0,
        rows: 100,
        totalRecords: 0,
        filters:{global: "",
                 table:"order",
                 globalFilterFields: ['OrderCode', 'CustomerId__LastName','CustomerId__City']
                },

      },
      proformOptions: [],
      selectedProform: null,
      oldProformCode: "",
    }
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },
  validations () {
    return {
      box: {
        //code: { required: helpers.withMessage('Kód nesmie byť prázdny', required),
        //        minLength: helpers.withMessage('Kód musí obsahovať min. 3 znaky', minLength(1)),
        //      },
        order:{ orderCode: {required: helpers.withMessage('Objednávka musí byť vyplnená', required),}}

      },

      selectedProform: {
          required: helpers.withMessage('Číslo nesmie byť prázdne', required),
                  minLength: helpers.withMessage('Číslo musí obsahovať min. 3 znaky', minLength(3)),
               
      }
    }
  },
  methods: {
    closeBox() {
      this.$confirm.require({
          message: 'Naozaj chcete krabicu zavrieť?',
          header: 'Zatvorenie krabice',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            this.box.opened = false
            this.actionWithBox = "CLOSE"
            this.submitHandler()
          },

      });
    },

    openBox() {
      this.box.opened = true
      this.box.openedAt = new Date()
      this.actionWithBox = "OPEN"
      this.submitHandler()
    },

    async submitHandler() {
      const result = await this.v$.$validate()
      if (!result) {
        // notify user form is invalid
        return
      }

      const boxId = parseInt(String(this.routeParams.boxId), 10)
      //console.log('userId:', userId)
      //let depart = this.departOptions.filter(obj => obj.id == this.user.department)[0]  
      //console.log('Depart:', depart)
      const payload = {
        id: this.box.id,
        code: this.box.code,
        location: this.box.location,
        customer: this.box.order.customer,     
        order: this.box.order,   
        opened: this.box.opened,
        openedAt: this.box.openedAt,
        received: this.box.received,
        receivedAt: this.box.receivedAt,
        cortizoProform: this.selectedProform.id ? this.selectedProform : {id:0, code: this.selectedProform},        
        deleted: false
      }

      let method = "POST"
      let url = "/v1/box/"
      if (boxId > 0){
        method = "PUT"
        url = "/v1/box/" + boxId
      }else{
        this.typeOfAction = "ADD"
      }

      fetch(store.Api_url + url, Security.requestOptions(method, payload))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //console.log("error:", responseData.data.message);
              //this.$emit('error', responseData.data.message);
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Krabica bola uložená"
              })
              this.box = responseData.data
              this.addStockMovement()
              this.oldLocation = this.box.location
              if (this.box.cortizoProform){
                  this.oldProformCode = this.box.cortizoProform.code
                  if (this.box.cortizoProform.id>0){
                    
                    this.selectedProform = this.box.cortizoProform
                  }else{
                    this.selectedProform = ""
                  }
                }else{
                  this.oldProformCode = ""
                  this.selectedProform = ""                 
                  this.box.cortizoProform = {id:0,code:""}
                }
              //this.oldProformCode = this.box.cortizoProform.code
              this.typeOfAction = ""
              this.actionWithBox = ""
              this.filterProforms(this.box.order.id)
              router.push("/mod-stock/boxies/"+String(this.box.id));
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri uložení krabice" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení krabice" + error
            })
          })


    },
    validateForm() {
      this.isSubmitted = true; // Mark the form as submitted to show validation feedback

    },
    selectOrder(order){
      //console.log("Order:", order)
        this.box.order = order
        this.box.customer = order.customer
        this.visibleSelect = false
        this.selectedProform = null
        this.filterProforms(order.id)
    },
    onOrderPage(event) {
        this.selectParams.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyDataOrders(this.selectParams)
    },
      
    onOrderFilter() {
        this.selectParams.filters.global = this.orderFilters.global.value
        this.selectParams.first = 0
        
        if(this.selectParams.filters.global.length > 2){
           this.loadLazyDataOrders(this.selectParams)
          }
    },

    initSelectFilters(){
        this.selectParams.first = 0
        this.selectParams.rows = 100
        this.selectParams.filters.global = ""
        this.orderfilters = {
            global: {value: null, matchMode: FilterMatchMode.CONTAINS},

        }
    },
    
    addStockMovement(){
      let dataMovement = {box:{id:this.box.id},
                              action:"",
                              user:store.user,
                              color:"",
                              order:{id:this.box.order.id}
                         }
      if  (this.typeOfAction == "ADD"){
        dataMovement.action = Utils.getAddTextAction("Krabica")
        Utils.addStockMovement(dataMovement,"box_id","ADD",this.box.id)
      }

      this.sleep(500);

      if (this.oldLocation != this.box.location){
         dataMovement.action = Utils.getChangeLocationTextAction("Krabica",this.box.location)
         Utils.addStockMovement(dataMovement,"box_id","CHA",this.box.id)
      }

      if (this.oldProformCode != this.box.cortizoProform.code){
         dataMovement.action = "Krabici bola priradená cortizo proforma s číslom "+ this.box.cortizoProform.code
         Utils.addStockMovement(dataMovement,"box_id","CHA",this.box.id)
      }      

      if  (this.actionWithBox == "OPEN"){
        dataMovement.action = Utils.getEventTextAction("Krabica","otvorená")
        Utils.addStockMovement(dataMovement,"box_id","CHA",this.box.id)
      }

      if  (this.actionWithBox == "CLOSE"){
        dataMovement.action = Utils.getEventTextAction("Krabica","zatvorená")
        Utils.addStockMovement(dataMovement,"box_id","CHA",this.box.id)
      }
      
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    printLabel(){
      Utils.printZplLabel(this.box.id,"box")
    },

    loadData(){

      if (parseInt(String(this.routeParams.boxId), 10) > 0) {
        // editing an existing color
        const boxId = String(this.routeParams.boxId)

        Utils.updateStockMovement("box_id",boxId)

        fetch(store.Api_url + "/v1/box/" + boxId, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                notie.alert({
                  type: 'error',
                  text: "Krabicu sa nepodarilo načítať: "+responseData.data.message
                })
              } else {
                //console.log(responseData);
                this.box = responseData.data
                this.oldLocation = this.box.location
                if (this.box.cortizoProform){
                  this.oldProformCode = this.box.cortizoProform.code
                  if (this.box.cortizoProform.id>0){
                    
                    this.selectedProform = this.box.cortizoProform
                  }else{
                    this.selectedProform = ""
                  }
                }else{
                  this.oldProformCode = ""
                  this.selectedProform = ""                 
                  this.box.cortizoProform = {id:0,code:""}
                }
                this.filterProforms(this.box.order.id)
              }
            })
            .catch((error) => {
              this.$emit('error', "Chyba pri načítaní krabice" + error);
              notie.alert({
                  type: 'error',
                  text: "Chyba pri načítaní krabice: "+error
                })
        })
      }else{
        store.stockMovements = []
      }
    },

    loadLazyDataOrders(params) {
        this.selectLoading = true;

        let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

        fetch(`${store.Api_url}${this.store.basicUrlFilterOrders}${queryParams}`, Security.requestOptions("POST",params.filters))
        .then((response) => response.json())
        .then((responseData) => {
          if (!responseData.error) {
            
            if(responseData.data){
              this.orderOptions = responseData.data
            }else{
              this.orderOptions = []
            }
            
            this.selectParams.totalRecords = responseData.totalRecords
            this.selectLoading = false;
          }
        })
        .catch((error) => {
          this.orderOptions = []
          this.selectLoading = false;
        })
      },

      filterProforms(orderId:number){
        fetch(this.store.Api_url + "/v1/cortizo-proform?query=deleted:0,order_id:"+orderId, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
              
                notie.alert({
                  type: 'error',
                  text: "Zoznam proforiem sa nepodarilo načítať"
                })
              } else {
                if (responseData.data){
                  this.proformOptions = responseData.data
                }else{
                  this.proformOptions = []
                }
              }
            })
            .catch((error) => {
              //this.$emit('error', "Chyba pri načítaní proforiem" + error);
              notie.alert({
                  type: 'error',
                  text: "Chyba pri načítaní proforiem" + error
                })
        })
      },
  },

  beforeRouteUpdate(to, from, next) {
        if (Security.requireToken()){
        this.routeParams = to.params
        store.selectModul = this.$route.path.split("/")[1]

        this.initSelectFilters()
        this.loadLazyDataOrders(this.selectParams)

        this.loadData()  

        next()
      }
  },

  beforeMount() {
    //console.log("calling user")
    if (Security.requireToken()){
      this.routeParams = this.$route.params
      store.selectModul = this.$route.path.split("/")[1]

      this.initSelectFilters()
      this.loadLazyDataOrders(this.selectParams)

      this.loadData()
    }

  }
}
</script>



<style scoped>

</style>